var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex h-full items-start overflow-scroll rounded-sm border border-ink-200 p-1 focus-within:shadow-white",class:[
    _vm.backgroundClass,
    _vm.resizable ? 'resize' : 'resize-none',
    {
      'cursor-not-allowed': _vm.disabled
    }
  ]},[_c('textarea',{directives:[{name:"debounce",rawName:"v-debounce:[debounceDelay]",value:({ func: _vm.updateDebounce, event: 'input' }),expression:"{ func: updateDebounce, event: 'input' }",arg:_vm.debounceDelay}],staticClass:"h-full w-full resize-none bg-transparent p-1 outline-none",class:[
      `text-${_vm.textSize}`,
      _vm.disabled ? 'text-slate' : `text-${_vm.textColor}`,
      {
        'cursor-not-allowed': _vm.disabled
      }
    ],attrs:{"maxlength":_vm.maxLength,"placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":_vm.updateSelf}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }